import React, { useEffect, useState, useRef } from 'react';
import { Space, Table, Tag, Card, Select, Flex } from 'antd';

import { Button, Checkbox, Form, Input, Divider } from 'antd';
import ImagePicker from "components/pickers/image/MultiImagePicker"
import ProductService from 'services/product';
import { useParams, useNavigate } from "react-router"
import { useForm, useWatch } from "antd/es/form/Form";
import ProductOptionService from 'services/product_option'
import ProductVariantService from 'services/product_variant'
import { useApp } from 'contexts/app';
import InputNumber from "components/input-number"
import { PlusOutlined } from '@ant-design/icons';
import _ from "lodash"
const service = new ProductService();
const productOptionService = new ProductOptionService();
const productVariantService = new ProductVariantService();

const ProductOption = ({ id, value, onChange, onAddNewValue }) => {
    useEffect(() => {
        loadData();
    }, [id])
    const { prompt } = useApp();
    const [option, setOption] = useState({ values: [] })
    const loadData = async () => {
        var data = await productOptionService.get(id);
        setOption(data);
    }




    const addNewValue = () => {
        prompt({
            title: "Thêm mới giá trị", label: "Nhập Tên",
            onOk: async (text) => {
                const service = new ProductOptionService();
                var newValue = await service.createValue({ title: text, parent_id: id });
                await loadData();
                if (onAddNewValue) {
                    onAddNewValue(newValue);
                }
                setTimeout(() => {
                    var newValues = [...value];
                    newValues.push(newValue.id);
                    onChange(id, newValues);
                }, 1000)
            }
        });
    }

    const handleChange = async values => {


        var newValues = values;
        for (let index = 0; index < values.length; index++) {
            const element = values[index];
            var old = option.values.find(x => x.id == element);
            var byName = option.values.find(x => x.title == element);
            if (byName) {
                newValues = [...value, byName.id];

            } else {
                if (!old) {

                    const service = new ProductOptionService();
                    var newValue = await service.createValue({ title: element, parent_id: id });
                    var newO = { ...option, values: [...option.values, { id: newValue.id, title: newValue.title }] }
                    setOption(newO);
                    await onAddNewValue(newValue);
                    newValues = [...value, newValue.id];

                }
            }

        }
        newValues = _.uniq(newValues);
        onChange(id, newValues)

    };




    return (
        <Select
            mode="tags"
            style={{ width: '100%' }}
            placeholder={option.title}
            value={value}
            //onChange={e => onChange(id, e)}
            onChange={handleChange}

            options={(option.values ?? []).map(v => ({ value: v.id, label: v.title }))}

            dropdownRender={menu => (
                <>
                    {menu}
                    <Divider style={{ margin: '8px 0' }} />
                    <Space style={{ padding: '0 8px 4px' }}>
                        Nhấn enter để tạo thêm thuộc tính mới
                    </Space>
                </>
            )}

        />
    )
};
export default ProductOption;